import React, { useEffect, useState } from "react";
import { Field, Form, Formik } from "formik";
import Cookies from "universal-cookie";
import { registorOwner } from "../utils/Validation";
import informationIcon from "../images/information-button.png";
import { base_url } from "../api/Axios";
import { LendingModal } from "../widgets/LendingModal";
import { config } from "../config";

const RegistorOwner = () => {
  const cookies = new Cookies();
  const token = cookies.get("token");
  let access = cookies.get("access");

  const martial_status = [
    {
      value: "MARRIED",
      display_name: "Married",
    },
    {
      value: "NOT_MARRIED",
      display_name: "Single",
    },
    {
      value: "DIVORCED",
      display_name: "Divorced",
    },
    {
      value: "WIDOWED",
      display_name: "Widowed",
    },
  ];
  const gender = [
    {
      value: "MALE",
      display_name: "Male",
    },
    {
      value: "FEMALE",
      display_name: "Female",
    },
  ];
  //
  const [ownerForm, setOwnerForm] = useState({
    first_name: "",
    middle_name: "",
    last_name: "",
    phone: "",

    gender: "",
    martial_status: "",
    minimum_monthly_income: "",
    average_daily_income: "",

    account_number: "",
    ownership_number: "",
    chassis_number: "",
    engine_number: "",

    plate_number: "",
    vehicle_make: "",
    year_of_make_date: "",
    ownership_certificate: null,
  });

  const [error, setError] = useState();
  const [success, setSuccess] = useState();
  const [errorBulk, setErrorBulk] = useState();
  const [successBulk, setSuccessBulk] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [ownership_certificate, setOwnershipCertificate] = useState(null);
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const url = `${base_url}vehicles/`;
  const openModal = (values) => {
    let updatedOwnerForm = {
      ...values,
      ownership_certificate: ownership_certificate,
    };
    let updatedPhone = updatedOwnerForm.phone;
    if (updatedPhone.trim().startsWith("0")) {
      updatedPhone = updatedPhone.replace(/^0/, "251");
      console.log(updatedPhone);
      updatedOwnerForm = { ...updatedOwnerForm, phone: updatedPhone };
      setOwnerForm(updatedOwnerForm);
    } else if (updatedPhone.trim().startsWith("+")) {
      updatedPhone = updatedPhone.replace("+", " ");
      console.log(updatedPhone);
      updatedOwnerForm = { ...updatedOwnerForm, phone: updatedPhone };
      setOwnerForm(updatedOwnerForm);
    } else {
      setOwnerForm(updatedOwnerForm);
    }
    console.log(updatedOwnerForm);
    setModalIsOpen(true);
  };

  const closeModal = () => {
    setModalIsOpen(false);
  };

  const handleNext = () => {
    setCurrentPage(currentPage + 1);
  };
  const handleBack = () => {
    setCurrentPage(currentPage - 1);
  };
  return (
    <div className="relative  bg-white">
      <div className="  responsive-aware-form flex  items-center justify-center   pb-8">
        <div className=" flex item-center    p-8">
          <div className="flex flex-col items-center  justify-center">
            <div className="flex flex-col items-center  justify-center">
              <img src={config.logo} alt="logo" className="h-14 pb-2" />
              <h1 className="text-center font-montserrata text-kacha-text3 pb-4">
                Register Vehicle & Owner
              </h1>
              <div className="flex ">
                <img src={informationIcon} alt="logo" className="h-6 pr-2" />
                Please enter all mandatory fields indicated with
                <span className="text-red-500 pl-2 pr-2 font-semibold">*</span>
                before proceed to next page!
              </div>
            </div>
            <Formik
              initialValues={ownerForm}
              validationSchema={registorOwner}
              onSubmit={(values) => {
                openModal(values);
              }}
            >
              {(formik) => (
                <Form method="post" enctype="multipart/form-data">
                  {currentPage === 1 && (
                    <>
                      <div className="mt-5" />
                      <div className="flex flex-col">
                        <label className="mb-1 text-kacha-text9">
                          First Name <span className="text-red-500">*</span>
                        </label>
                        <Field
                          className="border border-gray-300 p-3 rounded-md text-kacha-text9 min-w-[300px] max-w-[400px]"
                          name="first_name"
                          as="input"
                          type="text"
                        />
                        {formik.errors.first_name &&
                          formik.touched.first_name && (
                            <div className="error text-red-500">
                              {formik.errors.first_name}
                            </div>
                          )}
                      </div>
                      <div className="mt-5" />
                      <div className="flex flex-col">
                        <label className="mb-1 text-kacha-text9">
                          Middle Name <span className="text-red-500">*</span>
                        </label>
                        <Field
                          className="border border-gray-300 p-3 rounded-md text-kacha-text9 min-w-[300px] max-w-[400px]"
                          name="middle_name"
                          as="input"
                          type="text"
                        />
                        {formik.errors.middle_name &&
                          formik.touched.middle_name && (
                            <div className="error text-red-500">
                              {formik.errors.middle_name}
                            </div>
                          )}
                      </div>
                      <div className="mt-5" />
                      <div className="flex flex-col">
                        <label className="mb-1 text-kacha-text9">
                          Last Name Name <span className="text-red-500">*</span>
                        </label>
                        <Field
                          className="border border-gray-300 p-3 rounded-md text-kacha-text9 min-w-[300px] max-w-[400px]"
                          name="last_name"
                          as="input"
                          type="text"
                        />
                        {formik.errors.last_name &&
                          formik.touched.last_name && (
                            <div className="error text-red-500">
                              {formik.errors.last_name}
                            </div>
                          )}
                      </div>
                      <div className="mt-5" />
                      <div className="flex flex-col min-w-[300px] max-w-[400px]">
                        <label className="mb-1 text-kacha-text9">
                          Phone Number<span className="text-red-500">*</span>
                        </label>
                        <fieldset className="flex flex-row text-left min-w-[300px] max-w-[400px]">
                          <div className="relative ">
                            <div className="absolute inset-y-0 left-0 flex  p-3 pointer-events-none text-center">
                              <div className="flag-icon">🇪🇹 +</div>
                            </div>
                            <Field
                              className="border-l border-t border-b border-gray-300 p-3 rounded-l-md text-kacha-text9 min-w-[40px] max-w-[60px] text-center"
                              name="countryCode"
                              as="input"
                              type="text"
                              disabled
                            />
                          </div>
                          <div className="flex flex-col">
                            <Field
                              className="border border-gray-300 p-3 rounded-r-md text-kacha-text9 min-w-[340px] max-w-[340px]"
                              name="phone"
                              as="input"
                              type="text"
                            />
                            {formik.errors.phone && formik.touched.phone && (
                              <div className="error text-red-500">
                                {formik.errors.phone}
                              </div>
                            )}
                          </div>
                        </fieldset>
                      </div>
                      <div className="mt-5" />
                      <div className="flex flex-col">
                        <label>
                          Gender <span className="text-red-500">*</span>
                        </label>
                        <Field
                          className="border border-gray-300 p-3 rounded-md text-kacha-text9 min-w-[300px] max-w-[400px]"
                          name="gender"
                          as="select"
                        >
                          <option value="">--</option>
                          {gender.map((list) => (
                            <option key={list.value} value={list.value}>
                              {list.display_name}
                            </option>
                          ))}
                        </Field>
                        {formik.errors.gender && formik.touched.gender && (
                          <div className="error text-red-500">
                            {formik.errors.gender}
                          </div>
                        )}
                      </div>
                      <div className="mt-5" />
                      <div className="flex flex-col">
                        <label>Marital Status</label>
                        <Field
                          className="border border-gray-300 p-3 rounded-md text-kacha-text9 min-w-[300px] max-w-[400px]"
                          name="martial_status"
                          as="select"
                        >
                          <option value="">--</option>
                          {martial_status.map((list) => (
                            <option key={list.value} value={list.value}>
                              {list.display_name}
                            </option>
                          ))}
                        </Field>
                        {formik.errors.martial_status &&
                          formik.touched.martial_status && (
                            <div className="error text-red-500">
                              {formik.errors.martial_status}
                            </div>
                          )}
                      </div>

                      <div className="mt-5" />

                      <button
                        className=" bg-kacha-orange-700 text-center  m-2 p-3 min-w-[200px] text-white rounded-md text-lg"
                        type="button"
                        onClick={handleNext}
                        disabled={
                          !!formik.errors.first_name ||
                          !!formik.errors.middle_name ||
                          !!formik.errors.last_name ||
                          !!formik.errors.phone ||
                          !!formik.errors.gender ||
                          Object.keys(formik.touched).length <= 0
                        }
                      >
                        Next
                      </button>
                    </>
                  )}

                  {currentPage === 2 && (
                    <>
                      <div className="mt-5" />
                      <div className="flex flex-col">
                        <label className="mb-1 text-kacha-text9">
                          Monthly Income
                        </label>
                        <Field
                          className="border border-gray-300 p-3 rounded-md text-kacha-text9 min-w-[300px] max-w-[400px]"
                          name="minimum_monthly_income"
                          as="input"
                          type="number"
                        />
                        {formik.errors.minimum_monthly_income &&
                          formik.touched.minimum_monthly_income && (
                            <div className="error text-red-500">
                              {formik.errors.minimum_monthly_income}
                            </div>
                          )}
                      </div>
                      <div className="mt-5" />
                      <div className="flex flex-col">
                        <label className="mb-1 text-kacha-text9">
                          Daily Income
                          <span className="text-red-500">*</span>
                        </label>
                        <Field
                          className="border border-gray-300 p-3 rounded-md text-kacha-text9 min-w-[300px] max-w-[400px]"
                          name="average_daily_income"
                          as="input"
                          type="number"
                        />
                        {formik.errors.average_daily_income &&
                          formik.touched.average_daily_income && (
                            <div className="error text-red-500">
                              {formik.errors.average_daily_income}
                            </div>
                          )}
                      </div>
                      <div className="mt-5" />
                      <div className="flex flex-col">
                        <label className="mb-1 text-kacha-text9">
                          Bank Account
                        </label>
                        <Field
                          className="border border-gray-300 p-3 rounded-md text-kacha-text9 min-w-[300px] max-w-[400px]"
                          name="account_number"
                          as="input"
                          type="text"
                          // placeholder="Number of Employees"
                        />
                        {formik.errors.account_number &&
                          formik.touched.account_number && (
                            <div className="error text-red-500">
                              {formik.errors.account_number}
                            </div>
                          )}
                      </div>
                      <div className="mt-5" />
                      <div className="flex flex-col">
                        <label className="mb-1 text-kacha-text9">
                          Libre Certificate
                          <span className="text-red-500">*</span>
                        </label>
                        <Field
                          className="border border-gray-300 p-3 rounded-md text-kacha-text9 min-w-[300px] max-w-[400px]"
                          name="ownership_number"
                          as="input"
                          type="text"
                          // placeholder="Number of Employees"
                        />
                        {formik.errors.ownership_number &&
                          formik.touched.ownership_number && (
                            <div className="error text-red-500">
                              {formik.errors.ownership_number}
                            </div>
                          )}
                      </div>
                      <div className="mt-5" />
                      <div className="mt-5" />

                      <div className="mt-5" />
                      <div className="flex flex-col">
                        <label className="mb-1 text-kacha-text9">
                          Chassis Number
                        </label>
                        <Field
                          className="border border-gray-300 p-3 rounded-md text-kacha-text9 min-w-[300px] max-w-[400px]"
                          name="chassis_number"
                          as="input"
                          type="text"
                        />
                        {formik.errors.chassis_number &&
                          formik.touched.chassis_number && (
                            <div className="error text-red-500">
                              {formik.errors.chassis_number}
                            </div>
                          )}
                      </div>
                      <div className="mt-5" />

                      <div className="flex">
                        <button
                          type="button"
                          onClick={handleBack}
                          className=" bg-kacha-orange-700 text-center cursor-pointer m-2 p-3 min-w-[200px] text-white rounded-md text-lg"
                        >
                          Back
                        </button>

                        <div className="mt-5" />
                        <button
                          className=" bg-kacha-orange-700 text-center  m-2 p-3 min-w-[200px] text-white rounded-md text-lg"
                          type="button"
                          onClick={handleNext}
                          disabled={
                            !!formik.errors.average_daily_income ||
                            !!formik.errors.ownership_number ||
                            Object.keys(formik.touched).length <= 0
                          }
                        >
                          Next
                        </button>
                      </div>
                    </>
                  )}
                  {currentPage === 3 && (
                    <>
                      <div className="mt-5" />
                      <div className="flex flex-col">
                        <label className="mb-1 text-kacha-text9">
                          Engine Number
                        </label>
                        <Field
                          className="border border-gray-300 p-3 rounded-md text-kacha-text9 min-w-[300px] max-w-[400px]"
                          name="engine_number"
                          as="input"
                          type="text"
                        />
                        {formik.errors.engine_number &&
                          formik.touched.engine_number && (
                            <div className="error text-red-500">
                              {formik.errors.engine_number}
                            </div>
                          )}
                      </div>
                      <div className="mt-5" />
                      <div className="flex flex-col">
                        <label className="mb-1 text-kacha-text9">
                          Plate Number <span className="text-red-500">*</span>
                        </label>
                        <Field
                          className="border border-gray-300 p-3 rounded-md text-kacha-text9 min-w-[300px] max-w-[400px]"
                          name="plate_number"
                          as="input"
                          type="text"
                        />
                        {formik.errors.plate_number &&
                          formik.touched.plate_number && (
                            <div className="error text-red-500">
                              {formik.errors.plate_number}
                            </div>
                          )}
                      </div>
                      <div className="mt-5" />
                      <div className="flex flex-col">
                        <label className="mb-1 text-kacha-text9">
                          Vehicle Make
                        </label>
                        <Field
                          className="border border-gray-300 p-3 rounded-md text-kacha-text9 min-w-[300px] max-w-[400px]"
                          name="vehicle_make"
                          as="input"
                          type="text"
                        />
                        {formik.errors.vehicle_make &&
                          formik.touched.vehicle_make && (
                            <div className="error text-red-500">
                              {formik.errors.vehicle_make}
                            </div>
                          )}
                      </div>
                      <div className="mt-5" />
                      <div className="flex flex-col">
                        <label className="mb-1 text-kacha-text9">
                          Year of Make
                        </label>
                        <Field
                          className="border border-gray-300 p-3 rounded-md text-kacha-text9 min-w-[300px] max-w-[400px]"
                          name="year_of_make_date"
                          as="input"
                          type="text"
                        />
                        {formik.errors.year_of_make_date &&
                          formik.touched.year_of_make_date && (
                            <div className="error text-red-500">
                              {formik.errors.year_of_make_date}
                            </div>
                          )}
                      </div>

                      <div className="mt-5" />
                      <div className="flex flex-col">
                        <label className="mb-1 text-kacha-text9">
                          Ownership Certificate{" "}
                          <span className="text-red-500">*</span>
                        </label>
                        <input
                          className="border border-gray-300 p-3 rounded-md text-kacha-text9 min-w-[300px] max-w-[400px]"
                          name="ownership_certificate"
                          as="input"
                          type="file"
                          accept="image/*"
                          onChange={(e) => {
                            formik.setFieldValue(
                              "ownership_certificate",
                              e.target.files && e.target.files[0]
                            );
                            setOwnershipCertificate(
                              e.target.files && e.target.files[0]
                            );
                          }}
                        />
                        {formik.errors.ownership_certificate &&
                          formik.touched.ownership_certificate && (
                            <div className="error text-red-500">
                              {formik.errors.ownership_certificate}
                            </div>
                          )}
                      </div>

                      <div className="mt-5" />
                      <div className="text-kacha-text10 ">
                        By proceeding you are accepting terms and conditions of
                        the owner.
                      </div>
                      <div className="mt-5" />
                      <>
                        {success && (
                          <div className="text-green-700 text-kacha-text7 p-2  z-50 bg-white">
                            {success}
                          </div>
                        )}
                        {error && (
                          <div className="text-red-500 text-kacha-text7 p-2  z-50 bg-white">
                            Please Try Again. {error} !!
                          </div>
                        )}
                      </>
                      <div className="flex">
                        <button
                          type="button"
                          onClick={handleBack}
                          className=" bg-kacha-orange-700 text-center cursor-pointer m-2 p-3 min-w-[200px] text-white rounded-md text-lg"
                        >
                          Back
                        </button>

                        <button
                          className=" bg-kacha-orange-700 text-center  m-2 p-3 min-w-[200px]  text-white rounded-md text-lg"
                          type="submit"
                          disabled={
                            !!formik.errors.plate_number ||
                            !!formik.errors.ownership_certificate ||
                            Object.keys(formik.touched).length <= 0
                          }
                        >
                          Review and Submit
                        </button>
                      </div>
                    </>
                  )}
                  <div className="mt-5" />

                  <div type="submit" className="flex">
                    <LendingModal
                      isOpen={modalIsOpen}
                      closeModal={closeModal}
                      reviewData={ownerForm}
                      url={url}
                      role="MAKER"
                      type="OWNER"
                    />
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistorOwner;
